module.exports = __webpack_public_path__ + "static/media/button-save-spiner.ae013f76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/button-save-spiner.svg
// module id = 420
// module chunks = 21